<template>
  <Card
    class="koc-default-collection-item-lesson"
    :image-link="FormattingService.formatUrl(item)"
    :image-url="state.imageUrl"
    footer-text="VIEW LESSON"
    :footer-link="FormattingService.formatUrl(state.item)"     
  >
    <template #content>
      <div class="koc-default-collection-item-lesson-content">
        <div class="koc-default-collection-item-lesson-content-title koc-title koc-montserrat">
          <a
            :href="FormattingService.formatUrl(state.item)"
            v-html="state.item.title"
          />
        </div>
        <div
          class="koc-default-collection-item-lesson-content-body"
        >
          <p
            class="koc-default-collection-item-lesson-content-body-instructors"
            v-html="FormattingService.memberDashboardLinkedInstructorArray(state.item.instructors)"
          />
          <p v-html="state.truncateBody" />
        </div>
      </div>
    </template>  
  </Card>
</template>

<script src="./lesson.js"></script>
<style lang="scss" scoped src="./lesson.scss"></style>